module.exports = __webpack_public_path__ + "news-4a753f38/emptystate_submodule-847b3254bb630996333022a959f4dc09.svg";